import { CreateReportType, MarketplaceReports } from "TypesAndInterfaces";
import React, { ReactNode } from "react";
import { useState } from "react";


interface IReportsContext {
  selectedReport: CreateReportType;
  setSelectedReport: React.Dispatch<React.SetStateAction<CreateReportType>>;
  marketplaceReports: MarketplaceReports[];
  setMarketplaceReports: React.Dispatch<React.SetStateAction<MarketplaceReports[]>>;
}

export const ReportsContext = React.createContext<IReportsContext>({
} as IReportsContext);

interface ReportsProviderProps {
  children: ReactNode;
}

const ReportsProvider: React.FC<ReportsProviderProps> = ({ children }) => {
  const [selectedReport, setSelectedReport] = useState<CreateReportType>( {
    id: undefined,
    sqlFunctionName: undefined,
    marketplaceId: undefined,
    hour: undefined,
    schedule: undefined,
    emails: "",
    name: ""
  });
  const [marketplaceReports, setMarketplaceReports ] = useState<MarketplaceReports[]>([])

  const marketplaceContext = {
    selectedReport,
    setSelectedReport,
    marketplaceReports,
    setMarketplaceReports
  }

  return (
    <ReportsContext.Provider value={marketplaceContext}>
      {children}
    </ReportsContext.Provider>
  );
};

export default ReportsProvider;